export class RequestAllegatoOrdineDownload
{
    public lam?: string;    
}